import React from 'react';
import { motion } from 'framer-motion';
import { bookInfoRo } from '../../../data/bookDataRo';
import { FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const editions = [
  { label: 'Ediție Kindle', price: '$6.99', href: null, primary: true, key: 'kindle' },
  { label: 'Broșată', price: '$17.99', href: null, primary: false, key: 'paperback' },
  { label: 'Cartonată', price: '$26.99', href: null, primary: false, key: 'hardcover' },
];

const ExcerptCtaRo = () => (
  <section className="py-24 bg-brand-dark border-t border-white/5 relative overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-accent/5 via-transparent to-transparent"></div>
    <div className="max-w-3xl mx-auto px-6 text-center relative z-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-3">
          Cumpără Cartea pe Amazon
        </h2>
        <p className="text-gray-400 mb-10 text-lg">
          Cinci secole. Opt lumi. Un semnal care schimbă totul.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-10">
          {editions.map((ed) => (
            <a
              key={ed.label}
              href={bookInfoRo.links.amazon[ed.key]}
              target="_blank"
              rel="noreferrer"
              className={`flex flex-col items-center justify-center gap-1 px-8 py-5 rounded-xl font-bold transition-all group ${
                ed.primary
                  ? 'bg-brand-accent text-brand-dark hover:bg-brand-accentHover'
                  : 'bg-white/5 text-white border border-white/15 hover:bg-white/10'
              }`}
            >
              <span className="text-base">{ed.label}</span>
              <span className={`text-sm font-normal ${ed.primary ? 'text-brand-dark/70' : 'text-gray-400'}`}>
                {ed.price}
              </span>
            </a>
          ))}
        </div>

        <a
          href={bookInfoRo.links.amazon.kindle}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 text-brand-accent hover:text-white transition-colors text-sm font-medium"
        >
          Cumpără pe Amazon <SafeIcon icon={FiArrowRight} />
        </a>
      </motion.div>
    </div>
  </section>
);

export default ExcerptCtaRo;